module.exports = __webpack_public_path__ + "98d13397.svg";